<template>
  <div>
    <div class="container">

      <Tabs>
        <TabSection :title="$t('parameters')" collapsible>
          <div class="columns">
            <div class="column">
              <div class="group">
                <label>{{ $t('start') }}</label>
                <datetime v-model="start" type="datetime" value-zone="local" input-id="p_start" input-style="width: 100%"
                  :max-datetime="end" :use12-hour="is12HourFormat" />
              </div>
            </div>

            <div class="column">
              <div class="group">
                <label>{{ $t('end') }}</label>
                <datetime v-model="end" type="datetime" value-zone="local" input-id="p_end" input-style="width: 100%"
                  :min-datetime="start" :use12-hour="is12HourFormat" />
              </div>
            </div>
          </div>

          <button class="btn btn-primary" @click="createReport">{{ $t('generate') }}</button>
        </TabSection>

        <TabSection v-if="reportData">
          <RawTable :columns="reportData.columns" :rows="reportData.rows" :keyValueHeader="reportData.query" />
        </TabSection>
      </Tabs>

    </div>
  </div>
</template>

<script>
  import { Core } from "@/core/Core";
  import RawTable from "@/components/RawTable";
  import { DateTime } from "luxon";

  export default {
    name: "CustomReportQrCodeSales",

    components: { RawTable },

    data() {
      return {
        start: null,
        end: null,
        reportData: null
      }
    },

    computed: {
      company() {
        return this.$store.state.contextCompany;
      },
      is12HourFormat() {
        return parseInt(this.company ? this.company.hourFormat : '24') === 12
      }
    },

    mounted() {
      this.$store.state.pageTitleTranslationKey = 'custom_reports.codes_sales';
      this.$store.state.pageIcon = '';

      this.start = DateTime.local().startOf('month').toISO();
      this.end = DateTime.local().endOf('month').toISO();
    },

    methods: {
      fixDateTime(datetime) {
        return datetime.replace('T', ' ').substr(0, 19)
      },
      async createReport() {
        let options = {
          company: this.company ? this.company.id : undefined,
          start: this.start ? this.fixDateTime(this.start) : undefined,
          end: this.end ? this.fixDateTime(this.end) : undefined
        };

        this.$store.commit("showSpinner", true);
        try { this.reportData = await Core.request('GET', '/api/custom_reports/yqb_sales', options); }
        catch (e) {
          toast(this.$t("error.no_server"), 'error');
        }
        this.$store.commit("showSpinner", false);
      }
    }
  }
</script>